import { useQuery } from "@tanstack/react-query";
import useKothar from "context/useKothar";
import { getAdmissionDocuments } from "utils/admissionWorkflowService";

/**
 * Signed college documents are filed into the `admission_documents` table (see
 * `CollegeDocumentCompletionListener`), a different store from the manual attachments this tab
 * otherwise manages. This hook fetches that table's rows and keeps only the signed ones, so the
 * PDF a client just signed shows up here instead of being reachable nowhere in the UI.
 */
export function useAdmissionSignedDocuments(admissionId) {
  const [{ token }] = useKothar();

  const { data, isLoading } = useQuery({
    queryKey: ["admissionSignedDocuments", admissionId],
    queryFn: async () => {
      const res = await getAdmissionDocuments(admissionId, null, token);
      return res?.data?.data ?? [];
    },
    enabled: Boolean(admissionId),
    refetchOnWindowFocus: false,
  });

  const signedDocuments = (data ?? [])
    .filter((doc) => Boolean(doc.signedAt))
    .map((doc) => ({
      id: `signed-${doc.id}`,
      name: doc.documentName,
      url: doc.fileUrl,
      addedAt: doc.uploadedAt,
      addedBy: doc.uploadedBy,
      signedAt: doc.signedAt,
      readOnly: true,
    }));

  return { signedDocuments, isLoading };
}
